import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';

interface CU04801State {
    isInitiating: boolean;
}

const initialState: CU04801State = {
    isInitiating: false,
};

export const CU04801Slice = createSlice({
    name: 'CU04801Slice',
    initialState,
    reducers: {
        setInitiating: (state, action) => {
            state.isInitiating = action.payload;
        },
        resetCU04801Slice: () => initialState,
    },
});

export const { setInitiating, resetCU04801Slice } = CU04801Slice.actions;

export default CU04801Slice.reducer;
